/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M7.83 2h8.333a2.5 2.5 0 0 1 2.5 2.5v15a2.5 2.5 0 0 1-2.5 2.5H7.83a2.5 2.5 0 0 1-2.5-2.5v-15A2.5 2.5 0 0 1 7.83 2Zm-.833 2.917v12.916c0 .23.186.417.416.417h9.167c.23 0 .417-.186.417-.417V4.917a.417.417 0 0 0-.417-.417H7.413a.417.417 0 0 0-.416.417Z"
})), "0 0 24 24", "DeviceMobile");